<template>
  <div>
    <b-card>
      <b-card-text>
        <span>Esto es un formulario con validaciones</span>
      </b-card-text>

      <!-- form -->
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Nombres"
                  rules="required"
                >
                  <b-form-input
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nombres"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </b-col>
            <b-col cols="12">
              <b-button
                variant="primary"
                type="submit"
                @click.prevent="validationForm"
              >
                Submit
              </b-button>
            </b-col>
          </b-row>
        </b-form>

      </validation-observer>

    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import {
  BFormInput, BRow, BCol, BFormGroup, BCardText, BButton, BCard, BForm,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  components: {
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BCardText,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BForm,
  },
  props: {
    options: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      name: '',
      required,
    }
  },
  setup() {
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // eslint-disable-next-line no-alert
          alert('Se ha enviado el formualrio')
        }
      })
    },
  },
}
</script>
